import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ViewCell } from 'src/app/board/pages/admin/admin-components/custom-views-config/view-builder/models/view-builder.models';
import { CellComponent } from './base-cell.interface';

@Component({
  template: ''
})
export abstract class BaseCellComponent implements CellComponent, OnInit, OnChanges {
  @Input() cell!: ViewCell;
  @Input() isEditMode: boolean = false;
  @Input() pdfEditMode: boolean = false;
  @Input() data?: any;

  ngOnInit(): void {
    this.initializeCell();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cell'] || changes['data']) {
      this.onCellOrDataChange();
    }
  }

  setCell(cell: ViewCell): void {
    this.cell = cell;
    this.initializeCell();
  }

  updateCell(updatedCell: ViewCell): void {
    this.cell = updatedCell;
    this.onCellUpdate();
  }

  getData(): any {
    return this.data;
  }

  setData(data: any): void {
    this.data = data;
    this.onDataSet(data);
  }

  // Method to reload/refresh cell data (e.g., when context data changes)
  reloadData(): void {
    // Default implementation - can be overridden by child components
    this.onDataSet(this.data);
  }

  // Abstract methods that must be implemented by child components
  protected abstract initializeCell(): void;
  protected abstract onCellOrDataChange(): void;
  protected abstract onCellUpdate(): void;
  protected abstract onDataSet(data: any): void;

  // Utility method to get configuration value with default
  protected getConfigValue<T>(key: string, defaultValue: T): T {
    return this.cell?.configuration?.[key] ?? defaultValue;
  }

  // Utility method to get data binding value
  protected getDataBindingValue(key: string): any {
    return this.cell?.dataBinding?.[key];
  }
}